import React from 'react';
import {Atom} from '@packages/systems/wfdl';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createDevlinkAtom} from '@packages/utilities/integrated-types';
import {getChildren} from '@packages/utilities/data-utils';

const Figcaption = Atom.createRender(
  ({attributes, classes, generateAttributes, data, renderChild}) => {
    return (
      <figcaption {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child) => renderChild(child))}
      </figcaption>
    );
  }
);

const config = createDevlinkAtom({
  displayName: 'Figure Caption',
  showEmpty: false,
  render: Figcaption,
  fields: {children: TListOfElement},
});

export default config;
